export const getIlsLists = state => state.contactLists.byIlsId;
export const getIlsListsFetchStatuses = state => state.contactLists.fetchStatusByIlsId;
export const getFetchAllIlsListsRequestStatus = state => state.contactLists.fetchAllIlsListsRequestStatus;
export const getIlsList = (state, props) => state.contactLists.byIlsId[props.listId];
export const getIlsListFetchStatus = (state, props) => {
  return state.contactLists.fetchStatusByIlsId[props.listId];
};
export const getSelectedIlsListsAsOptions = (state, selectedIlsListIds) => {
  const {
    contactLists
  } = state;
  if (!selectedIlsListIds) return [];
  return selectedIlsListIds.map(ilsListId => {
    const existingContactList = contactLists.byIlsId[ilsListId];
    if (existingContactList) {
      return {
        text: existingContactList.name,
        value: ilsListId
      };
    }
    return {
      text: ' ',
      value: ilsListId
    };
  });
};